export const LANGUAGE_FIELDS = {
  cultures: {
    fields: {
      fr: 'french_name',
      en: 'english_name',
      lat: 'latin_name',
    },
    labels: {
      fr: 'Français',
      en: 'English',
      lat: 'Latin',
    },
    defaultLanguage: 'fr',
  },
  enemies: {
    fields: {
      fr: 'french_name',
      en: 'english_name',
      lat: 'latin_name',
    },
    labels: {
      fr: 'Français',
      en: 'English',
      lat: 'Latin',
    },
    defaultLanguage: 'fr',
  },
};

export const BASIC_FILTER_CONFIGS = [
  {
    key: 'product_names',
    labelKey: 'product|filters.Product name',
    field: 'name.keyword',
  },
  {
    key: 'active_substance_names',
    labelKey: 'product|filters.Active substance name',
    field: 'active_substances.active_substance.name.keyword',
  },
  {
    key: 'activity_sectors',
    labelKey: 'product|filters.Activity sector',
    field: 'activities_sector',
    value_field: 'id',
    label_field: 'name',
  },
  {
    key: 'organic_approval',
    labelKey: 'product|filters.Organic approval',
    field: 'is_organic_approval',
    type: 'boolean_select',
  },
  {
    key: 'cultures',
    labelKey: 'product|filters.Culture (from treatments)',
    field: 'cultures',
    value_field: 'id',
    label_field: 'french_name',
    languageConfig: LANGUAGE_FIELDS.cultures,
  },
  {
    key: 'cultures_practices',
    labelKey: 'product|filters.Cultural practices',
    field: 'cultures.cultural_practices',
    value_field: 'id',
    label_field: 'name',
  },
  {
    key: 'enemies',
    labelKey: 'product|filters.Enemies',
    field: 'enemies',
    value_field: 'id',
    label_field: 'display_name',
    languageConfig: LANGUAGE_FIELDS.enemies,
  },
  {
    key: 'commercial_packagings',
    labelKey: 'product|filters.Commercial packagings',
    field: 'packagings.name.keyword',
  },
  {
    key: 'registration_numbers',
    labelKey: 'product|filters.Registration numbers',
    field: 'approval_number.keyword',
  },
];

export const AGRONOMIC_FILTER_CONFIGS = [
  {
    key: 'chemical_families',
    labelKey: 'active-substance|filters.Chemical families or biological families',
    field: 'pesticide_group_associations.chemical_family',
    value_field: 'id',
    label_field: 'label',
  },
  {
    key: 'pesticide_groups',
    labelKey: 'active-substance|filters.Pesticide groups',
    field: 'pesticide_group_associations.pesticide_group',
    value_field: 'id',
    label_field: 'name',
  },
  {
    key: 'pesticide_categories',
    labelKey: 'active-substance|filters.Pesticide categories',
    field: 'active_substances.active_substance.pesticide_categories',
    value_field: 'id',
    label_field: 'name',
  },
  {
    key: 'arla_culture_groups',
    labelKey: 'product|filters.ARLA Culture Groups',
    field: 'cultures.arla_culture_group',
    value_field: 'id',
    label_field: 'group',
  },
  {
    key: 'product_types',
    labelKey: 'product|filters.Product types',
    field: 'product_types',
    value_field: 'id',
    label_field: 'name',
  },
  {
    key: 'activity_types',
    labelKey: 'product|filters.Activity types',
    field: 'activity_type_associations.activity_type',
    value_field: 'id',
    label_field: 'label',
  },
  {
    key: 'application_types',
    labelKey: 'product|filters.Application Types',
    field: 'application_types',
    value_field: 'id',
    label_field: 'name',
  },
  {
    key: 'allergens',
    labelKey: 'product|filters.Allergens',
    field: 'allergens',
    value_field: 'id',
    label_field: 'name',
  },
];

export const HEALTH_FILTER_CONFIGS = [
  {
    key: 'acute_toxicity',
    labelKey: 'active-substance|filters.Acute toxicity',
    field: 'active_substances.health.acute_toxicity_symbol_data.calculated_value',
    type: 'range_select',
  },
  {
    key: 'long_term_effects',
    labelKey: 'active-substance|filters.Long term effects',
    field: 'active_substances.health.long_term_effect_symbol_data.calculated_value',
    type: 'range_select',
  },
];

export const ENVIRONMENT_FILTER_CONFIGS = [
  {
    key: 'fish_or_daphnia',
    labelKey: 'active-substance|filters.Fish or daphnia',
    field: 'active_substances.environment.fishes_symbol_data.calculated_value',
    type: 'range_select',
  },
  {
    key: 'birds',
    labelKey: 'active-substance|filters.Birds',
    field: 'active_substances.environment.birds_symbol_data.calculated_value',
    type: 'range_select',
  },
  {
    key: 'bees',
    labelKey: 'active-substance|filters.Bees',
    field: 'active_substances.environment.bees_symbol_data.calculated_value',
    type: 'range_select',
  },
  {
    key: 'persistence',
    labelKey: 'active-substance|filters.Persistence',
    field: 'active_substances.environment.persistence_symbol_data.calculated_value',
    type: 'range_select',
  },
  {
    key: 'leaching_potential',
    labelKey: 'active-substance|filters.Leaching potential',
    field: 'active_substances.environment.leaching_symbol_data.calculated_value',
    type: 'range_select',
  },
];

export const BASIC_FILTER_KEYS = BASIC_FILTER_CONFIGS.map((c) => c.key);
export const EXTRA_FILTER_KEYS = [
  ...AGRONOMIC_FILTER_CONFIGS.map((c) => c.key),
  ...HEALTH_FILTER_CONFIGS.map((c) => c.key),
  ...ENVIRONMENT_FILTER_CONFIGS.map((c) => c.key),
];

export const DOCUMENT_TYPE = 'ProductDocument';